<template>
  <div class="entry-kantei-base">
    <base-attention v-if="attentionText" :text="attentionText" />
    <kantei-header
      :consumption-point="consumptionPoint"
      :user-point="userProfile.user_point | addComma"
    />
    <entry-kantei-not-form
      v-if="attentionText"
      :form-setting="formSetting"
    />
    <entry-kantei-form
      v-else
      :form-setting="formSetting"
      :user-data="userData"
      :action="action"
      :method="method"
      :token="token"
    />
  </div>
</template>

<script>
import BaseAttention from "../common/Attention"
import KanteiHeader from "./KanteiHeader"
import EntryKanteiNotForm from "./EntryKanteiNotForm"
import EntryKanteiForm from "./EntryKanteiForm"

export default {
  name: "EntryKantei",
  components: {
    BaseAttention,
    KanteiHeader,
    EntryKanteiNotForm,
    EntryKanteiForm
  },
  props: {
    userProfile: {
      type: Object,
      default () {
        return {}
      }
    },
    userData: {
      type: Object,
      default () {
        return {}
      }
    },
    consumptionPoint: {
      type: Number | String,
      default: 900
    },
    formSetting: {
      type: Object,
      default () {
        return {}
      }
    },
    action: String,
    method: String,
    token: String,
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // 注意テキスト
      attentionText: '',
    }
  },
  computed: {
    /**
     * ポイントが足りている
     * @return {Boolean}
     */
    isPointEnough () {
      return Number(this.userProfile.user_point) >= Number(this.consumptionPoint)
    }
  },
  created () {
    this.makeAttentionText ()
  },
  methods: {
    /**
     * エラーメッセージを作る
     * @return {Void} this.attentionText にテキスト代入
     */
    makeAttentionText () {
      // サブスク会員ではない場合は中止
      if (Number(subsc.active) !== 1) {
        return false
      }
      // 2週間無料の場合
      if (this.isSubscTrial && (!subsc.last_payment_at || subsc.last_payment_at === 'null')) {
        dbg.log('subsc.last_payment_at === falsy', subsc.last_payment_at)
        const date = window.moment(subsc.next_payment_due).format('YYYY年M月D日')
        this.attentionText = '2週間お試し期間中のためご利用できません。<br>' + date + '以降、サブスクリプションを継続するとお申し込みいただけます。'
      // ポイント不足の場合
      } else if (!this.isPointEnough) {
        dbg.log('this.isPointEnough === falsy', this.isPointEnough)
        this.attentionText =
          'ポイント不足です。' + this.consumptionPoint +
          'ポイント以上貯まったらお申し込みください。<br>' +
          '＊ポイントは毎月自動的に貯まります。それ以外にも超運2022年の運勢やオーダーメイド型占いをご購入の際も付与されます'
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.entry-kantei-base {
  padding: 32px 4px 60px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/EntryKantei.vue